import Vue from 'vue';

Vue.prototype.$locale = document.documentElement.lang;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Pimcore back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 * We also add axios as an global $http variable to our Vue variable
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.prototype.$http = window.axios;
